// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const authData = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    signUp: builder.mutation({
      query: (body) => ({
        url: `signup`,
        method: "POST",
        body,
      }),
      // transformResponse: (response, meta, arg) => response.data,
    }),
    login: builder.mutation({
      query: (body) => ({
        url: `login`,
        method: "POST",
        body,
      }),
      // transformResponse: (response, meta, arg) => response.data,
    }),
    checkLogin: builder.mutation({
      query: (body) => ({
        url: `check_login`,
        method: "POST",
        body,
      }),
      // transformResponse: (response, meta, arg) => response.data,
    }),
    getProfile: builder.query({
      query: (student_id) => ({
        url: `profile`,
        params: {
          student_id,
        },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSignUpMutation,
  useLoginMutation,
  useCheckLoginMutation,
  useGetProfileQuery,
} = authData;
